import React from "react"

import { connect } from "scrivito"

import { ExternalDimensioningBaseProductCard } from "./ExternalDimensioningBaseProductCard"
import { useExternalDimensioningBaseProductCardModel } from "./model/useExternalDimensioningBaseProductCardModel"

interface ExternalDimensioningBaseProductCardConnectorProps {
  variantKey: string
}

function ExternalDimensioningBaseProductCardConnectorComponent({
  variantKey
}: ExternalDimensioningBaseProductCardConnectorProps) {
  return (
    <ExternalDimensioningBaseProductCard
      {...useExternalDimensioningBaseProductCardModel({ variantKey })}
    />
  )
}

export const ExternalDimensioningBaseProductCardConnector = React.memo(
  connect(ExternalDimensioningBaseProductCardConnectorComponent)
)
